import React, { ReactNode } from 'react';
import classNames from 'classnames/bind';

import { PageLayoutContext } from '../context/page_layout';
import { ContainerSize } from './Container';
import styles from '../PageLayout.module.scss';

const c = classNames.bind(styles);

/** @deprecated */
export type PageLayoutProps = {
  className?: string;
  children: ReactNode;
  /** @default default */
  size?: ContainerSize;
};

/** @deprecated */
function Root(
  { className, children, size = 'default' }: PageLayoutProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  return (
    <PageLayoutContext.Provider value={{ size }}>
      <div className={c(className, 'root')} ref={ref}>
        {children}
      </div>
    </PageLayoutContext.Provider>
  );
}
/** @deprecated */
const forwardedRef = React.forwardRef(Root);
/** @deprecated */
const memoized = React.memo(forwardedRef);

/** @deprecated */
export { memoized as Root };
